import React from 'react'
import { Box, Button, Grid2, Typography } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import { TextFormField } from '../../shared/components/FormFields/TextFormField'
import { isValidPhoneNumber } from "react-phone-number-input";
import { FormAutoComplete } from '../../shared/components/FormFields/FormAutoComplete'
import { PhoneInputFormField } from '../../shared/components/FormFields/PhoneInputFormField'
import AddIcon from '@mui/icons-material/Add';
import ContactPersonList from './ContactPersonList'
import useContactStore from '../../shared/store/contactStore'
// import { useGetContactPersonDetailList } from '../../assets/api/useGetApi';


const ContactPersonDetail = ({ designationOption }) => {
    const { addContactPerson } = useContactStore();
    const contactPersonSchema = yup.object().shape({
        name: yup.string().required("Name is required"),
        mobile_no: yup.string().test(
            "is-phone",
            "Phone number is not valid",
            (value) => value && isValidPhoneNumber(value)
        ).required("Mobile Number is required"),
        email: yup.string().email("Invalid email").required("E-Mail is required"),
        designation: yup.string().required("Designation is required")
    });

    const handleFunc = async (values, resetForm, validateForm, setTouched) => {
        await setTouched({
            name: true,
            mobile_no: true,
            email: true,
            designation: true
        });

        const errors = await validateForm(); // Validate form

        if (Object.keys(errors).length === 0) {
            addContactPerson(values);
            resetForm();
        }
    };
    return (
        <Box>
            <Formik
                initialValues={{
                    name: "",
                    mobile_no: "",
                    email: "",
                    designation: ""
                }}
                validationSchema={contactPersonSchema}
            >
                {({ values, resetForm, validateForm, setTouched }) => (
                    <Form >
                        <Grid2 container spacing={5}>

                            <Grid2
                                size={12}
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr auto",
                                    alignItems: "start"
                                }}
                            >
                                <Typography variant='h6' fontSize={"18px"} fontWeight={600}>
                                    Contact Person Details
                                </Typography>

                            </Grid2>

                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="name"
                                    component={TextFormField}
                                    label="Name"
                                    isRequired={true}
                                    type={"name"}
                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="mobile_no"
                                    component={PhoneInputFormField}
                                    label="Mobile Number"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="email"
                                    component={TextFormField}
                                    label="E-Mail"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={{ xs: 12, sm: 6 }}>
                                <Field
                                    name="designation"
                                    component={FormAutoComplete}
                                    options={designationOption}
                                    label="Designation"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 size={12} sx={{ display: "flex", justifyContent: "end" }}>
                                <Button
                                    variant='contained'
                                    startIcon={<AddIcon sx={{ color: "red.main" }} />}
                                    onClick={() => handleFunc(values, resetForm, validateForm, setTouched)}
                                >
                                   Save & Add Another
                                </Button>
                            </Grid2>
                        </Grid2>
                        <CustomDivider />

                    </Form>)}
            </Formik>
            <Typography variant='h6' fontSize={"18px"} fontWeight={600}>Added Contact Person </Typography>
            <CustomDivider size={30} />
            <ContactPersonList />
        </Box>
    )
}

export default ContactPersonDetail